module.exports = __webpack_public_path__ + "gift.3c94b6a5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/desktopView/gift.gif
// module id = 1639
// module chunks = 1